export default "__VITE_ASSET__BsTx9vaI__"